export const analytics = {
  title: "Analityka",
  subtitle: "Przychody i obłożenie Twoich obiektów w wybranym okresie.",
  tabs: {
    performance: "Wyniki",
    channels: "Kanały",
  },
  allAccommodations: "Wszystkie obiekty",
  compare: {
    prevPeriod: "Poprzedni okres",
    prevYear: "Poprzedni rok",
    titlePrevPeriod: "Porównanie: poprzedni okres",
    titlePrevYear: "Porównanie: poprzedni rok",
    inlinePrevPeriod: "poprzedni okres",
    inlinePrevYear: "poprzedni rok",
  },
  summary: {
    currentPeriod: "Bieżący okres",
    paymentFilter: "Filtr płatności",
  },
  presets: {
    today: "Dziś",
    yesterday: "Wczoraj",
    d7: "7 dni",
    d30: "30 dni",
    m3: "3 miesiące",
    m6: "6 miesięcy",
    year: "1 rok",
  },
  payment: {
    all: "Wszystkie płatności",
    pending: "Oczekujące",
    paid: "Opłacone",
    rejected: "Odrzucone",
    refunded: "Zwrócone",
    partial: "Płatność częściowa",
  },
  kpi: {
    totalRevenue: "Przychód w okresie",
    arrivalRevenue: "Łączna wartość przyjazdów",
    revpar: "RevPAR",
    occupancyRate: "Wskaźnik obłożenia",
    adr: "ADR",
    avgStay: "Średni pobyt",
    bookingWindow: "Wyprzedzenie rezerwacji",
  },
  units: {
    days: " dni",
  },
  chart: {
    thisPeriod: "Bieżący okres",
    subtitle: "{current} · porównanie: {compared} · {payment}",
  },
  channels: {
    directBookings: "Rezerwacje bezpośrednie",
    otaBookings: "Rezerwacje z OTA",
    bookingDetails: "Szczegóły rezerwacji",
    byChannel: "Wg kanału",
    tableChannel: "Kanał",
    tableRevenue: "Przychód",
    direct: "Bezpośrednie",
    ota: "OTA",
    noData: "Brak danych dla wybranego okresu",
  },
  a11y: {
    chartOf: "Wykres: {label}",
    directVsOta: "Wykres rezerwacji bezpośrednich i z OTA",
  },
};
